export class Select2Options implements Select2Options {
    ajax: Select2AjaxOptions;
    allowClear: boolean;
    amdBase: string;
    amdLanguageBase: string;
    closeOnSelect: boolean;
    containerCss: any;
    containerCssClass: any;
    createTag: any;
    data: any;
    dataAdapter: any;
    debug: boolean;
    disabled: boolean;
    dropdownAdapter: any;
    dropdownAutoWidth: boolean;
    dropdownCss: any;
    dropdownCssClass: any;
    dropdownParent: JQuery;
    escapeMarkup: (markup: string) => string;
    formatInputTooShort: (term: string, minLength: number) => string;
    formatLoadMore: (pageNumber: number) => string;
    formatNoMatches: (term: string) => string;
    formatResult: (object: any, container: JQuery, query: any, escapeMarkup: (markup: string) => string) => string;
    formatResultCssClass: (object: any) => string;
    formatSearching: () => string;
    formatSelection: (object: any, container: JQuery, escapeMarkup: (markup: string) => string) => string;
    formatSelectionTooBig: (maxSize: number) => string;
    id: (object: any) => string;
    initSelection: (element: JQuery, callback: (data: any) => void) => void;
    language: string | string[] | {};
    matcher: (term: string, text: string, option: any) => boolean;
    maximumInputLength: number;
    maximumSelectionLength: number;
    minimumInputLength: number;
    minimumResultsForSearch: number;
    multiple: boolean;
    openOnEnter: boolean;
    placeholder: string | IdTextPair;
    query: (options: Select2QueryOptions) => void;
    resultsAdapter: any;
    selectOnClose: boolean;
    selectionAdapter: any;
    separator: string;
    sorter: (data: any[]) => any[];
    tags: any;
    templateResult: (object: Select2SelectionObject) => any;
    templateSelection: (object: Select2SelectionObject, container: JQuery) => any;
    theme: string;
    tokenSeparators: string[];
    tokenizer: (input: string, selection: any[], selectCallback: () => void, options: Select2Options) => string;
    width: string;
}
